if (!window.RamonGalleryDots) {
  window.RamonGalleryDots = {
    init: function () {
      document.querySelectorAll('.gallery-dots:not([data-initialized])').forEach((container) => {
        const sliderComponent = container.closest('slider-component');
        if (!sliderComponent) return;

        const slides = Array.from(sliderComponent.querySelectorAll('[id^="Slide-"]'));
        if (slides.length < 2) return;

        container.setAttribute('data-initialized', 'true');
        container.innerHTML = '';

        const sliderList = sliderComponent.querySelector('[id^="Slider-"]');
        const dots = slides.map((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'slider-counter__link slider-counter__link--dots link';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `${index + 1} / ${slides.length}`);
          if (sliderList) dot.setAttribute('aria-controls', sliderList.id);
          if (index === 0) {
            dot.classList.add('slider-counter__link--active');
            dot.setAttribute('aria-current', 'true');
          }

          const dotMark = document.createElement('span');
          dotMark.className = 'dot';
          dot.appendChild(dotMark);

          dot.addEventListener('click', () => {
            if (!sliderComponent.slider) return;
            sliderComponent.slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          });

          container.appendChild(dot);
          return dot;
        });

        sliderComponent.addEventListener('slideChanged', (event) => {
          const activeIndex = slides.indexOf(event.detail.currentElement);
          dots.forEach((dot, index) => {
            const isActive = index === activeIndex;
            dot.classList.toggle('slider-counter__link--active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        });
      });
    },
  };

  document.addEventListener('DOMContentLoaded', window.RamonGalleryDots.init);
  document.addEventListener('shopify:section:load', window.RamonGalleryDots.init);
}
